import { calculatePricing, type Pricing } from '#shared/types';

/**
 * The calculator's inputs, shaped exactly as `calculatePricing` takes them, so
 * the quote is priced by the same function the bill is.
 */
export type QuoteCharges = Required<Parameters<typeof calculatePricing>[0]>;

export const EMPTY_CHARGES: QuoteCharges = {
  discount_percentage: 0,
  discount_rupees: 0,
  tax_percentage: 0,
  other_charges: 0,
  paid: 0,
};

/**
 * The two discounts are mutually exclusive, exactly as on the registration
 * form: `calculatePricing` lets the percentage win if both somehow arrive, and
 * clearing the other here means the operator never sees that rule fire.
 */
export function withDiscountPercentage(charges: QuoteCharges, percentage: number): QuoteCharges {
  return { ...charges, discount_percentage: percentage, discount_rupees: 0 };
}

export function withDiscountRupees(charges: QuoteCharges, rupees: number): QuoteCharges {
  return { ...charges, discount_rupees: rupees, discount_percentage: 0 };
}

/** Prices the selected tests; a test whose price is unknown counts as free. */
export function priceQuote(
  charges: QuoteCharges,
  testIds: readonly number[],
  priceById: ReadonlyMap<number, number>,
): Pricing {
  return calculatePricing(
    charges,
    testIds.map((testId) => priceById.get(testId) ?? 0),
  );
}
